<template>
  <div
    type="button"
    class="tw-py-3 tw-my-1 tw-px-3 tw-w-full"
    :class="isActive ? 'tw-bg-light dark:tw-bg-dm-light tw-rounded-xl' : ''"
  >
    <div class="tw-flex tw-items-center tw-mb-2">
      <i-user-avatar
        :avatar="thread.foreigner_avatar_url && thread.foreigner_avatar_url['128'] && `${$baseHost}/${thread.foreigner_avatar_url['128']}`"
        :fullname="thread.foreigner_fullname"
        size="mini"
        class="tw-mr-3 tw-cursor-pointer"
        @click.stop="navigateToForeignerPage"
      />
      <div class="tw-flex tw-flex-col">
        <div
          class="tw-flex tw-mb-1 tw-cursor-pointer hover:tw-underline"
          @click.stop="navigateToForeignerPage"
        >
          <span class="tw-font-medium tw-leading-5 tw-tracking-wider">
            {{ thread.foreigner_fullname }}
          </span>
        </div>
        <div class="tw-flex">
          <span class="tw-text-xs tw-leading-[14px]">
            {{ thread.subject }}
          </span>
        </div>
      </div>
    </div>

    <div class="tw-text-gray-dark dark:tw-text-dm-gray-dark tw-flex tw-justify-between tw-mb-1">
      <span class="tw-text-xs tw-leading-[14px]">
        {{ thread.user_from_fullname }}
      </span>
      <time class="tw-text-xs tw-leading-[14px]">
        {{ thread.date_created }}
      </time>
    </div>
    <div class="tw-flex tw-items-center tw-justify-between">
      <p
        v-if="messageDraft"
        class="tw-mb-0 tw-leading-5 tw-tracking-normal tw-flex tw-items-center tw-max-w-full"
      >
        <span class="tw-capitalize tw-text-primary">
          {{ $t('messaging.draft_message') }}:&nbsp;
        </span>
        <span
          class="tw-text-ellipsis tw-whitespace-nowrap tw-overflow-hidden tw-inline-block tw-flex-1"
        >
          {{ messageDraft }}
        </span>
      </p>
      <p
        v-else
        class="tw-mb-0 tw-leading-5 tw-tracking-normal tw-text-ellipsis"
        :class="[
          thread.unseen_messages ? 'tw-font-bold' : '',
          filterBodySearch ? 'tw-text-gray-dark' : '',
        ]"
        v-html="threadBody"
      />
      <i-badge
        v-if="thread.unseen_messages"
        type="primary"
        size="small"
        class="tw-ml-2"
      >
        +{{ thread.unseen_messages }}
      </i-badge>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    thread: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState({
      me: (state) => state.v2.shared.profile.me,
      filterBodySearch: (state) => state.v2.admin.messaging.fulltextSearchValue,
      foreigner: (state) => state.v2.admin.messaging.foreigner,
      openedThreadData: (state) => state.v2.admin.messaging.openedThreadData,
    }),
    messageDraft() {
      return this.$store.state.v2.admin.messaging.notSentMessages?.[this.thread.foreigner_id]?.[this.thread.permit_id];
    },
    threadBody() {
      let body = this.$sanitize(this.thread.body).replace(/\n/g, ' ');

      if (this.filterBodySearch && this.filterBodySearch.length > 0) {
        const pattern = new RegExp('(' + this.filterBodySearch + ')', 'gi');
        body = body.replace(pattern, '<span class="tw-text-dark">$1</span>');
      }

      return body;
    },
  },
  methods: {
    navigateToForeignerPage() {
      this.$router.push({
        name: 'foreignersPermit',
        params: {
          fid: this.thread.foreigner_id,
        },
      });
    },
  },
};
</script>
